export var PersonType;
(function (PersonType) {
    PersonType["PRIVATE_PERSON"] = "Soukrom\u00E1 osoba";
    PersonType["BUSINESSMAN"] = "Podnikatel";
    PersonType["COMPANY"] = "Firma";
})(PersonType || (PersonType = {}));
